import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form-caption form-caption--xs form-caption--error form-caption--sm" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ErrorMessage',
    props: {
        error: String,
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.error), 1 /* TEXT */));
        };
    }
});
